module.exports = __webpack_public_path__ + "static/img/setion3_3.114e437.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/setion3_3.png
// module id = 7TNZ
// module chunks = 1